import Clock from './time/clock/Clock.js';
export default Clock;